import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { LanguageDto } from "@api/language-dto";
import { PropType, computed, toRef } from "vue";
import { useSelectField } from "./select";
import SelectBase from "./SelectBase.vue";
import publicFormApi from "@/publicFormApi";
import { ApiResponse } from "@/publicFormApi/apiResponse";
import { getLanguageTranslation } from "@/helpers";


export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageSelect',
  props: {
	valueSingle: {
		type: [Object, null] as PropType<LanguageDto | null | undefined>,
	},
	valueSingleId: {
		type: [Number, String, null] as PropType<number | string | null | undefined>,
	},
	valueMulti: {
		type: [Array, null] as PropType<LanguageDto[] | null | undefined>,
	},
	ajax: {
		type: Boolean,
		default: false,
	},
	isInvalid: {
		type: Boolean,
	},
	id: {
		type: String,
	},
	communicationRole: {
		type: Number as PropType<number>,
		required: false,
	},
	placeholder: {
		type: String,
	},
},
  emits: [
	"update:valueSingle",
	"update:valueSingleId",
	"update:valueMulti",
	"blur",
],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props;

const {
	cValueSingle,
	cValueMulti,
	optionGenerator,
	optionIdentifier,
	optionsGetter,
	nonAjaxOptions,
} = useSelectField<LanguageDto>(
	toRef(() => props.valueSingle),
	toRef(() => props.valueMulti),
	toRef(() => props.ajax),
	(val) => emit("update:valueSingle", val),
	(val) => emit("update:valueSingleId", val?.code || null),
	(val) => emit("update:valueMulti", val),
	(search?: string, page?: number) => {
		if (!props.communicationRole) {
			return publicFormApi.call.form.get.languages(search, page);
		}

		const getCommLangs = async () => {
			if (props.ajax) {
				const response = await publicFormApi.call.form.get.searchCommunicationLanguages(
					search || "",
					props.communicationRole
				);

				if (response.isSuccessful && response.data) {
					return new ApiResponse<LanguageDto[]>(
						response.data.map((r) => r.language!) as LanguageDto[],
						false,
						false,
						null
					);
				}

				return response as unknown as ApiResponse<LanguageDto[]>;
			} else {
				const response = await publicFormApi.call.form.get.allCommunicationLanguages(
					props.communicationRole
				);

				if (response.isSuccessful && response.data) {
					return new ApiResponse<LanguageDto[]>(
						response.data.map((r) => r.language!) as LanguageDto[],
						false,
						false,
						null
					);
				}

				return response as unknown as ApiResponse<LanguageDto[]>;
			}
		};

		return getCommLangs();
	},
	(lang: LanguageDto) => {
		return {
			text: getLanguageTranslation(lang) ?? "",
			value: lang,
		};
	},
	(val) => val.code
);

const optionsGetterIfAjax = computed(() => {
	if (props.ajax) {
		return optionsGetter;
	}
	return undefined;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SelectBase, {
    valueMulti: _unref(cValueMulti),
    "onUpdate:valueMulti": _cache[0] || (_cache[0] = ($event: any) => (_isRef(cValueMulti) ? (cValueMulti).value = $event : null)),
    valueSingle: _unref(cValueSingle),
    "onUpdate:valueSingle": _cache[1] || (_cache[1] = ($event: any) => (_isRef(cValueSingle) ? (cValueSingle).value = $event : null)),
    ajax: __props.ajax,
    onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('blur'))),
    id: __props.id,
    optionGenerator: _unref(optionGenerator),
    optionComparer: _unref(optionIdentifier),
    optionLoader: optionsGetterIfAjax.value,
    options: _unref(nonAjaxOptions),
    placeholder: __props.placeholder
  }, {
    default: _withCtx(({ openMenu }) => [
      _renderSlot(_ctx.$slots, "default", { openMenu: openMenu })
    ]),
    _: 3
  }, 8, ["valueMulti", "valueSingle", "ajax", "id", "optionGenerator", "optionComparer", "optionLoader", "options", "placeholder"]))
}
}

})